import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://26151d91ca35803061313e39c24721ed@o4509349034393600.ingest.us.sentry.io/4510414516715520",
  //   integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  //   tracesSampleRate: 1.0, // Performance monitoring
  //   replaysSessionSampleRate: 0.1, // Session replay 10% sample
  //   replaysOnErrorSampleRate: 1.0, // Replay 100% on error
  sendDefaultPii: true,
});
